<template>
  <div style="">
    <div
      style="
        width: 100%;
        display: inline-flex;
        align-items: start;
        position: relative;
        line-height: 16px;
      "
    >
      <upload-button
        @onSuccess="callback"
        :type="type"
        :text="file_url ? buttonName[1] : buttonName[0]"
      ></upload-button>
      <div
        style="display: inline-flex; margin-left: 10px; position: relative"
        v-if="file_url"
      >
        <div
          v-if="file_url && file_type != 'audio'"
          style="
            position: absolute;
            width: 100%;
            height: 100px;
            cursor: pointer;
            z-index: 10;
          "
          @click="view"
        ></div>
        <img
          v-if="file_type == 'image'"
          :src="file_url"
          style="max-height: 100px"
        />
        <video
          :id="videoId"
          v-if="file_type == 'video'"
          style="max-height: 100px"
          controls
          useCORS="true"
          crossOrigin="Anonymous"
          @loadeddata="videoLoaded"
        >
          <source :src="file_url" />
        </video>
        <audio v-if="file_type == 'audio'" controls>
          <source :src="file_url" />
        </audio>
      </div>
      <div
        v-if="file_url"
        style="
          color: #556ee6;
          cursor: pointer;
          margin-left: 10px;
          padding-bottom: 16px;
        "
        @click="deleteFile"
      >
        删除
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import { uploadFile } from "@/server/api/cos.js";
import videoCut from "@/util/videoCut";
import { waitTime } from "@/util/fun.js";
export default {
  data() {
    return {
      file_type: "",
      file_url: "",
      file_cover: "",
      videoLoading: false,
    };
  },
  props: {
    fileUrl: {
      type: String,
      default: "",
    },
    fileType: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "imageOrVideoOrAudio",
    },
    buttonName: {
      type: Array,
      default: () => {
        return ["上传文件", "更换文件"];
      },
    },
    videoId: {
      type: String,
      default: "video",
    },
    getCover: {
      type: Boolean,
      default: false,
    },
    cover: {
      type: String,
      default: "",
    },
  },
  methods: {
    callback(obj) {
      console.log("得到的数据", obj);
      this.file_type = obj.type;
      this.file_url = obj.data;
      this.$emit("update:fileUrl", obj.data);
      this.$emit("update:fileType", obj.type);
      if (this.file_type == "video") {
        if (this.getCover) {
          if (obj.cover) {
            this.$emit("update:cover", obj.cover);
            this.file_cover = obj.cover;
            this.$emit("change", {
              type: obj.type,
              url: obj.data,
              cover: obj.cover,
            });
          } else {
            this.videoLoading = true;
            this.$emit("update:cover", "");
            this.$emit("change", {
              type: obj.type,
              url: obj.data,
            });
            this.getVideoCover();
          }
        } else {
          this.$emit("change", {
            type: obj.type,
            url: obj.data,
          });
        }
      } else {
        this.$emit("change", {
          type: obj.type,
          url: obj.data,
        });
      }
    },
    view() {
      this.ShowImg(this.file_url, this.file_type);
    },
    deleteFile() {
      this.file_type = "";
      this.file_url = "";
      this.$emit("update:fileUrl", "");
      this.$emit("update:fileType", "");
      this.$emit("update:cover", "");
      this.$emit("change", {
        type: "",
        url: "",
        cover: "",
      });
    },
    async videoLoaded() {
      console.log("视频加载了");
      if (this.videoLoading == false) {
        //编辑时没有封面就自动获取封面
        if (!this.cover) {
          await waitTime(200);
          this.getVideoCover();
        }
      } else {
        //代表可以截取封面了
        this.videoLoading = false;
      }
    },
    async getVideoCover() {
      if (!this.getCover) {
        return;
      }
      if (this.videoLoading) {
        await waitTime(200);
        this.getVideoCover();
        return;
      }
      console.log("开始截取封面");
      const domId = this.videoId;
      const targetSaturation = 0;
      videoCut
        .getBestPoster(domId, targetSaturation)
        .then((posterUrl) => {
          // const image = new Image()
          // image.src = posterUrl
          // document.body.append(image)
          // return;
          let dataurl = posterUrl;
          let arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
          }
          let blob = new Blob([u8arr], { type: mime });
          blob.lastModifiedDate = new Date();
          blob.name = "video_cut_" + new Date().valueOf();
          //console.log("blob", blob);
          console.log("类型", blob.type, "名字", blob.name);
          let file = new window.File([blob], blob.name, {
            type: blob.type,
          });
          //console.log("file", file)
          uploadFile(file, blob.name)
            .then((res) => {
              console.log("cos upload res", res);
              if (res.status === "success") {
                this.file_cover = res.response.url;
                this.$emit("update:cover", res.response.url);
                this.$emit("change", {});
                console.log("封面图", this.file_cover);
              } else {
              }
            })
            .catch((e) => {
              console.log("cos upload err", res);
            })
            .finally((res) => {});
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    this.file_url = this.fileUrl;
    this.file_type = this.fileType;
    // if (this.file_url && this.file_type == "video" && !this.cover) {
    //   this.getVideoCover();
    // }
  },
  watch: {
    fileUrl(val) {
      // console.log("地址变化了");
      this.file_url = val;
    },
    fileType(val) {
      // console.log("类型变化了");
      this.file_type = val;
    },
  },
};
</script>

<style scoped>
::v-deep .app-upload-button {
  height: 28px !important;
}
</style>
